import React from 'react';
import { Icon, Wrapper, Count } from './StyledCommentsIndication';

export const CommentsIndication = ({ count, onClick }) => (
  <Wrapper onClick={onClick}>
    <Icon />
    <Count>{count}</Count>
  </Wrapper>
);
